// Unified admin model control helpers. Prices are READ-ONLY here (changing a price is a business decision made outside this UI).
export const STATUS_LABELS = {
  catalog_only: "Hanya katalog", schema_unavailable: "Skema tidak tersedia", schema_ready: "Skema siap (belum dijual)", active: "Aktif", disabled: "Dinonaktifkan",
};
export const statusLabel = (s) => STATUS_LABELS[s] || "Tidak diketahui";
export const DECISION_LABELS = { enabled: "Diaktifkan admin", disabled: "Dinonaktifkan admin", unset: "Belum diputuskan" };
export const decisionLabel = (d) => DECISION_LABELS[d] || "Tidak diketahui";

export const retailText = (retail) => {
  if (!retail || typeof retail !== "object" || !Number.isInteger(retail.credits_per_second)) return "Belum ditetapkan";
  const res = Array.isArray(retail.priced_resolutions) && retail.priced_resolutions.length ? ` (${retail.priced_resolutions.join(", ")})` : "";
  return `${retail.credits_per_second} kredit/detik${res}`;
};
export const providerPriceText = (price) => {
  if (!price || !Array.isArray(price.rates) || price.rates.length === 0) return "Belum dikenali";
  return price.rates.slice(0, 3).map((r) => `${r.key}: ${r.provider_credits}`).join("; ") + (price.unit ? ` (${price.unit})` : "");
};
// A model's decision can be changed here only when this catalog owns it; registry-owned models are changed in the registry panel.
export const canToggleHere = (m) => !!m && m.decision_owner === "model_admin_settings";
export const toggleWarning = (m, enabling) => {
  if (!enabling) return `Nonaktifkan ${m.title}? Generasi baru dengan model ini akan ditolak.`;
  const blockers = (m.blocker_labels || []).filter((b) => !/diaktifkan admin/i.test(b));
  return blockers.length
    ? `Aktifkan ${m.title}? Ini hanya keputusan admin: model TIDAK menjadi dapat dijual karena masih ada blocker — ${blockers.join(" ")}`
    : `Aktifkan ${m.title}?`;
};
export const catalogSummaryText = (s) => (s && Number.isInteger(s.total) ? `${s.total} model · ${s.sellable || 0} dapat dijual` : "Ringkasan belum tersedia");
export const errorText = (error) => (typeof error?.response?.data?.detail === "string" ? error.response.data.detail : "Permintaan belum berhasil. Coba lagi.");
export const PAGE_SIZE = 50;
